<template>
  <b-modal ref="addItemModal"
           id="modal-add-quiz"
           title="Добавить опрос"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name" label="Наменование">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите название опроса"
                        v-model="addForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';

export default {
  components: {
    alertMsg,
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        name: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-quiz';
      const path = this.host + 'add_quiz';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('quiz');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
            this.initForm();
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'name' : this.addForm.name,
      };
      this.addItem(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add-quiz');
      this.initForm();
    },
    initForm() {
      this.addForm.name = '';
    },
  },
  created() {
    // this.take_groups();
  },
};
</script>

<style scoped>

</style>
